/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import WhyJoinWealthy from "./WhyJoinWealthy.container";

export default WhyJoinWealthy;
